import { RootState } from "@/store/types";
import axios from "axios";
import { ActionTree } from "vuex";
import {
  StatisticState, WhatsappDetailFilterParams, WhatsappDetailItem,
  WhatsappDetailItemInfo, WhatsappGroupFilterParams, WhatsappGroupItem
} from "./types";

export const actions: ActionTree<StatisticState, RootState> = {

  async getWhatsappStatisticDetail({commit}, filter: WhatsappDetailFilterParams) {
    commit('setLoading', true);
    try {
      const resp = await axios({url: '/stats-api/detail/whatsapp', params: filter});
      let messages = resp.data?.messages ?? [];
      if (filter.page_number > 1) {
        commit('pushWhatsappStatisticDetail', messages);
      } else {
        commit('setWhatsappStatisticDetail', messages);
      }
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
  async getWhatsappStatisticDetailInfo({commit}, id: string) {
    commit('setLoading', true);
    try {
      const response = await axios({url: `/stats-api/detail/whatsapp/${encodeURIComponent(id)}`});
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportWhatsappStatisticDetail({commit}, filter: WhatsappDetailFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/detail/whatsapp/export', params: filter});
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
  async resendWhatsappMessage({commit}, id: string) {
    commit('setLoading', true);
    try {
      const response = await axios({
        method: 'post',
        url: '/acapi/tools/whatsapp/resend',
        data: {message_ids: [id]}
      })
      return response;
    } finally {
      commit('setLoading', false);
    }
  },

  async getWhatsappStatisticGroup({commit}, filter: WhatsappGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/whatsapp', params: filter});
      commit('setWhatsappStatisticGroup', response.data.messages);
      // commit('setWhatsappMessagesCount', response.data.messages_count);
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportWhatsappStatisticGroup({commit}, filter: WhatsappGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/whatsapp/export', params: filter});
      return response;
    } finally {
      commit('setLoading', false);
    }
  },
};
